import router from "@/router";
import { RouterProvider as Provider } from "react-router";
import { queryClient } from "@/app/providers/QueryProvider/client";
import { useContext } from "react";
import { ReactContext } from "@/app/providers/ReactContextProvider/react-context";

export function RouterProvider() {
  const { setErrorMessage } = useContext(ReactContext);
  return <Provider router={router(queryClient, setErrorMessage)} />;
}
